module.exports = __webpack_public_path__ + "img/slotmachine.cb3cda4d.png";